/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppointmentAvailability = {
    Busy: 'Busy',
    Free: 'Free'
} as const;
export type AppointmentAvailability = typeof AppointmentAvailability[keyof typeof AppointmentAvailability];


export function instanceOfAppointmentAvailability(value: any): boolean {
    for (const key in AppointmentAvailability) {
        if (Object.prototype.hasOwnProperty.call(AppointmentAvailability, key)) {
            if (AppointmentAvailability[key as keyof typeof AppointmentAvailability] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppointmentAvailabilityFromJSON(json: any): AppointmentAvailability {
    return AppointmentAvailabilityFromJSONTyped(json, false);
}

export function AppointmentAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAvailability {
    return json as AppointmentAvailability;
}

export function AppointmentAvailabilityToJSON(value?: AppointmentAvailability | null): any {
    return value as any;
}

export function AppointmentAvailabilityToJSONTyped(value: any, ignoreDiscriminator: boolean): AppointmentAvailability {
    return value as AppointmentAvailability;
}

